import apiService from './apiService';

class ProductService {
  async getProducts(skip = 0, limit = 500, activeOnly = false) {
    try {
      const endpoint = `/api/v1/product-types/?skip=${skip}&limit=${limit}${activeOnly ? '&active_only=true' : ''}`;
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch products:', error);
      throw error;
    }
  }
  
  async getAllProducts() {
    try {

      const endpoint = '/api/v1/product-types/?skip=0&limit=10000';
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch all products:', error);
      throw error;
    }
  }

  async getProductById(id) {
    try {
      const endpoint = `/api/v1/product-types/${id}`;
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error(`Failed to fetch product with id ${id}:`, error);
      throw error;
    }
  }

  async createProduct(productData) {
    try {
      const endpoint = '/api/v1/product-types/';
      const response = await apiService.post(endpoint, productData);
      return response;
    } catch (error) {
      console.error('Failed to create product:', error);
      throw error;
    }
  }

  async updateProduct(id, productData) {
    try {
      const endpoint = `/api/v1/product-types/${id}`;
      const response = await apiService.put(endpoint, productData);
      return response;
    } catch (error) {
      console.error(`Failed to update product with id ${id}:`, error);
      throw error;
    }
  }

  async deleteProduct(id) {
    try {
      const endpoint = `/api/v1/product-types/${id}`;
      const response = await apiService.delete(endpoint);
      return response;
    } catch (error) {
      console.error(`Failed to delete product with id ${id}:`, error);
      throw error;
    }
  }
}

export default new ProductService();